import { render, staticRenderFns } from "./BusMaster.vue?vue&type=template&id=73933d1d&scoped=true"
import script from "./BusMaster.vue?vue&type=script&lang=js"
export * from "./BusMaster.vue?vue&type=script&lang=js"
import style0 from "./BusMaster.vue?vue&type=style&index=0&id=73933d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73933d1d",
  null
  
)

export default component.exports